import styled from "styled-components";
import { apolloSpaceInset1X, apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
import { heightMedium, heightSmall } from "./MenuItem.style";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import { checkboxOuterSize } from "../checkbox/Checkbox.style";
const focusBorderStroke = 1;
export const getItemSize = ({ size, multiSelect }) => {
    const verticalPadding = getValueFromPixelString(apolloSpaceInsetHalfX) * 2;
    if (size === "medium") {
        return heightMedium + verticalPadding;
    }
    if (multiSelect) {
        // small items in the multiselect have the height of the checkbox,
        // because the line-height of its text is even smaller.
        return checkboxOuterSize + focusBorderStroke * 2 + (verticalPadding - focusBorderStroke * 2);
    }
    return heightSmall + verticalPadding;
};
export const StyledMenu = styled.ul.withConfig({ displayName: "StyledMenu_APC-7311-productShell", componentId: "sc-5uios9" })(({ theme, variant, menuVisibleItems, size, multiSelect }) => {
    const menuTopPadding = variant === "classic" || variant === "timeframepicker" ? getValueFromPixelString(apolloSpaceInset1X) : 0;
    return Object.assign({ background: theme.colors.apolloColorBackgroundMenuItemDefault, listStyle: "none", padding: menuTopPadding ? `${menuTopPadding}px 0` : 0, margin: 0, overflow: "auto", position: "relative", boxSizing: "border-box" }, (menuVisibleItems && {
        height: menuVisibleItems * getItemSize({ size, multiSelect }) + menuTopPadding * 2,
    }));
});
//# sourceMappingURL=Menu.style.js.map